import sanityClient from "@sanity/client"

export default sanityClient({
    projectId: "fg05t151",
    dataset: "production"
})